import React, { useState, useEffect } from "react";
import ButtonGroup from "../../buttons/ButtonGroup";
import { useFirstRender } from '../../utils/hooks';

const buttons = [
  {
    id: 0,
    text: "Priradiť práva cez projekty",
    value: [
      {
        id: 3,
        label: "Priradenie projektov",
      },
      {
        id: 4,
        label: "Nastavenie práv",
      },
    ],
  },
  {
    id: 1,
    text: "Priradiť práva cez skupiny používateľov",
    value: [
      {
        id: 5,
        label: "Priradenie skupín používateľov",
      },
      {
        id: 6,
        label: "Nastavenie práv",
      },
    ],
  },
];

const Method = ({ setItems, method, refresh }) => {
  // eslint-disable-next-line
  const [state, setState] = useState({});

  // aby useEffect(..., [refresh]) nesiel pri 1. rendery, 
  const firstRender = useFirstRender();

  // componentDidUpdate
  useEffect(() => {
    if (!firstRender) {
      setItems(method || buttons[0]);
    }
    // eslint-disable-next-line
  }, [refresh]);

  const handleChange = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
    setItems(value);
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <ButtonGroup
          data={buttons}
          onChange={handleChange}
          textField="text"
          dataItemKey="id"
          name="method"
        />
      </div>
    </>
  );

}

export default Method;
